// extracted by mini-css-extract-plugin
export var fullWidthButton = "_ee-0";